module.exports = __webpack_public_path__ + "img/skip-button-old.d9feb9a3.png";